import styled from "styled-components";

export const STAppWrapper = styled.div`
  position: relative;
`;
